// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ShippingBox } from './shipping-box';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BoxSize extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Decimal */
  height?: number;
  /** Decimal */
  length?: number;
  /** String(100) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Decimal */
  width?: number;
  /** Inv FK boxSizeId */
  shippingBoxes!: ShippingBox[];
}

